import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import api from "../api";
import PublicNavbar from "../components/PublicNavbar";
import { registerPushNotifications } from "../pushNotifications";

export default function Login({ mode = "auto" }) {
  const [form, setForm] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    if (!form.email.trim()) {
      return "Please enter your email address";
    }
    if (!/\S+@\S+\.\S+/.test(form.email)) {
      return "Please enter a valid email address";
    }
    if (!form.password) {
      return "Please enter your password";
    }
    return "";
  };

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }

    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", form);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      await registerPushNotifications({ requestPermission: true });
      navigate(["admin", "worker"].includes(data.user.role) ? "/admin/dashboard" : "/quotes", { replace: true });
    } catch (err) {
      setError(err.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-100">
      <PublicNavbar />
      <div className="min-h-[calc(100vh-76px)] grid place-items-center px-4 py-10">
      <form onSubmit={submit} className="w-full max-w-sm bg-white rounded-2xl shadow-xl p-8">
        <div className="text-center font-extrabold text-2xl text-slate-800">
          FIND <span className="text-red-600">AUTO</span> PARTS
        </div>
        <p className="text-center text-slate-500 text-sm mt-1 mb-6">{mode === "admin" ? "Admin / Staff Login" : mode === "user" ? "User Login" : "Sign in to your account"}</p>

        {error && <div className="bg-red-50 text-red-700 text-sm rounded-lg px-3 py-2 mb-4">{error}</div>}

        <input
          type="email"
          placeholder="Email"
          className="w-full px-4 py-3 mb-3 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          required
        />
        <div className="relative mb-4"><input
          type={showPassword ? "text" : "password"}
          placeholder="Password"
          className="w-full px-4 py-3 pr-20 rounded-lg border border-gray-200 text-sm focus:outline-none focus:ring-2 focus:ring-green-500"
          value={form.password}
          onChange={(e) => setForm({ ...form, password: e.target.value })}
          required
        /><button type="button" onClick={() => setShowPassword(v => !v)} className="absolute right-3 top-1/2 -translate-y-1/2 text-xs text-blue-700 font-semibold" aria-label={showPassword ? "Hide password" : "Show password"}>{showPassword ? "Hide" : "Show"}</button></div>

        <button
          type="submit"
          disabled={loading}
          className="w-full py-3 rounded-lg bg-green-600 text-white font-semibold hover:bg-green-700 disabled:opacity-60"
        >
          {loading ? "Signing in..." : "Login"}
        </button>

        <p className="text-center text-sm mt-4">
          <Link to="/" className="text-slate-500 hover:text-slate-700">← Back to home</Link>
        </p>
        <p className="text-center text-sm text-slate-600">
          New User?{" "}
          <Link to="/Register" className="text-green-600 font-semibold hover:text-green-700 transition">
            Register here
          </Link>
        </p>
      </form>
      </div>
    </div>
  );
}